import NewListComponents from "../components/NewsList";
import useNewsList from "../hook/useNewsList";

const NewsList = () => {
  const newsListProps = useNewsList();
  return <NewListComponents {...newsListProps} />;
};

export default NewsList;